import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=f98fdfa8"
import script from "./Stage.vue?vue&type=script&lang=ts"
export * from "./Stage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports